module.exports = __webpack_public_path__ + "img/Sonic_Drive-In_logo.bc7b0e20.svg";